import { useJobs } from 'providers/JobContext';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { JobStage } from 'services/api/jobStage';
import { usePermissions } from 'hooks/usePermissions';
import { PERMISSIONS } from 'constants/permissions';

interface JobStageFilterProps {
  stages: JobStage[];
}

export const JobStageFilter: React.FC<JobStageFilterProps> = ({ stages }) => {
  const { setSelectedStage, selectedStage } = useJobs();

  const [
    canViewNewJob,
    canViewEquipShipped,
    canViewEquipReturned,
    canViewOperatorDispatched,
    canViewOperatorReturned,
    canViewJobStaged
  ] = usePermissions([
    PERMISSIONS.DASHBOARD.ACTIVE_JOBS.JOBS_STAGES.NEW_JOB,
    PERMISSIONS.DASHBOARD.ACTIVE_JOBS.JOBS_STAGES.EQUIP_SHIPPED,
    PERMISSIONS.DASHBOARD.ACTIVE_JOBS.JOBS_STAGES.EQUIP_RETURNED,
    PERMISSIONS.DASHBOARD.ACTIVE_JOBS.JOBS_STAGES.OPERATOR_DISPATCHED,
    PERMISSIONS.DASHBOARD.ACTIVE_JOBS.JOBS_STAGES.OPERATOR_RETURNED,
    PERMISSIONS.DASHBOARD.ACTIVE_JOBS.JOBS_STAGES.JOB_STAGED
  ]);

  const getPermissionForStage = (stageName: string): boolean => {
    const lowerName = stageName.toLowerCase();

    if (lowerName.includes('new job')) return canViewNewJob;
    if (lowerName.includes('job staged')) return canViewJobStaged;
    if (lowerName.includes('operator returned')) return canViewOperatorReturned;
    if (lowerName.includes('operator dispatched'))
      return canViewOperatorDispatched;
    if (
      lowerName.includes('equipment shipped') ||
      lowerName.includes('equip shipped')
    )
      return canViewEquipShipped;
    if (lowerName.includes('equip returned')) return canViewEquipReturned;

    return false;
  };

  const permissionFilteredStages = stages.filter(stage => {
    const hasPermission = getPermissionForStage(stage.name);
    return hasPermission;
  });

  return (
    <Dropdown>
      <Dropdown.Toggle variant="primary" id="job-stage-filter">
        {selectedStage ? `Filter by: ${selectedStage}` : 'Filter by Stage'}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => setSelectedStage(null)}
          active={selectedStage === null}
        >
          All Stages
        </Dropdown.Item>
        {permissionFilteredStages.map(stage => (
          <Dropdown.Item
            key={stage.id}
            onClick={() => setSelectedStage(stage.name)}
            active={selectedStage === stage.name}
          >
            {stage.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
